import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Form from '../../../../form/field';
import fieldLogic from '../logic/fieldsLogic';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import helpers from '../utils/fieldsHelper';
import Typography from '@material-ui/core/Typography';
import useInputRef from './useInputRef';

var useSelectStyles = function useSelectStyles(props) {
  if (props.disabled) return {
    singleValue: function singleValue(base, state) {
      return _objectSpread({}, base, {
        color: '#555'
      });
    },
    multiValue: function multiValue(base, state) {
      return _objectSpread({}, base, {
        color: '#555'
      });
    }
  };
  return {};
};

var useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    '&$disabled': {
      color: '#555',
      opacity: 1,
      backgroundColor: '#eee'
    },
    '&$disabled $notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  },
  notchedOutline: {},
  disabled: {
    color: '#555',
    backgroundColor: '#eee'
  }
}, {
  name: 'ECFormFieldDropdown'
});

var ensureOptions = function ensureOptions(value, options) {
  if (options && options.length) return options;
  if (!value) return options;
  if (typeof value === 'string') return [{
    label: value,
    value: value
  }];
  return options;
};

var FormFieldDropdown = function FormFieldDropdown(_ref) {
  var value = _ref.value,
      options = _ref.options,
      active = _ref.active,
      fieldId = _ref.fieldId,
      dispatch = _ref.dispatch,
      error = _ref.error,
      multiple = _ref.multiple,
      readonly = _ref.readonly,
      variant = _ref.variant,
      description = _ref.description;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 2),
      inputRef = _useInputRef2[0],
      refNode = _useInputRef2[1];

  var classes = useStyles();
  var selectStyles = useSelectStyles({
    disabled: readonly
  });

  var onChange = function onChange(value) {
    fieldLogic.onChange(fieldId, value, dispatch);
    setTimeout(function () {
      refNode && refNode.focus();
    });
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var hasError = !!error;
  var values = ensureOptions(value, options);
  var descriptionContent = description ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(description)
    }
  }) : '';
  return React.createElement(Grid, null, React.createElement(Form.Input.MultiSelect, {
    textFieldProps: {
      FormHelperTextProps: {
        style: {
          marginTop: 4,
          marginLeft: 0
        },
        className: error ? 'help-error' : 'help-block'
      },
      InputProps: {
        classes: classes
      }
    },
    ref: inputRef,
    error: hasError,
    helperText: error || descriptionContent || React.createElement(Typography, null, " "),
    value: value || '',
    options: values,
    multi: multiple,
    variant: variant,
    disabled: readonly,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange,
    customSelectStyles: selectStyles,
    clearable: false,
    menuShouldBlockScroll: true,
    menuShouldScrollIntoView: false,
    menuPlacement: "auto"
  }));
};

export default React.memo(FormFieldDropdown);